import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PermissionCheck } from "@/components";
import { PermissionRoles } from "@/enum";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { ApiKeyTable } from "@/pages/Private/pages/Company/pages/ApiKeyOverview/components/ApiKeyTable";
import { CreateApiKeyModal } from "@/pages/Private/pages/Company/pages/ApiKeyOverview/components/CreateApiKeyModal";

const API_DOCS_URL = "https://docs.signalist.io";

/**
 * API-keys management surface shown on the Integrations "API" detail page. Relocated from the
 * former Company → Developer tab so keys, their documentation and webhooks live under Integrations.
 */
export const IntegrationApiKeys: FunctionComponent = () => {
	const { t } = useTranslation();
	const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);

	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-wrap items-center gap-2">
				<Link target="_blank" to={API_DOCS_URL}>
					<Button
						color={ButtonColor.ACTION_SECONDARY}
						size={ButtonSize.S}
						testId="api-docs-button"
						title={t("integrations.api.docsCta")}
					/>
				</Link>
				<PermissionCheck requiredPermissions={[PermissionRoles.API_KEY]}>
					<Button
						color={ButtonColor.ACTION}
						size={ButtonSize.S}
						testId="create-api-key-button"
						title={t("integrations.api.createCta")}
						onClick={() => setIsCreateModalOpen(true)}
					/>
				</PermissionCheck>
			</div>

			<ApiKeyTable />

			{isCreateModalOpen && (
				<CreateApiKeyModal isOpen={isCreateModalOpen} setIsOpen={setIsCreateModalOpen} />
			)}
		</div>
	);
};
